<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <svg-component />

    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 06'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgComponent from '../../assets/Modulo 2/diapositiva-10'

export default {
  components:{
    SvgComponent
  },
  data() {
    return {
      dialogos: [
        "Dentro de esta clasificación, ahondaremos un poco en las reservas. Recordemos que existen reservas probadas, probables y posibles." 
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', true)
  }
}
</script>
<style lang="scss" scoped>
</style>
